// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"63d846cc","455":"63abb975","977":"8c36a2e3"}[chunkId] + ".chunk.js";
};